import { Address, AddressGroup } from '../../../../dtos/version.dto';
import React, { useEffect, useMemo, useState } from 'react';
import { useStores } from '../../../store';
import { listCells } from '../inventory-utils';

interface AddressCellProps {
    addressGroupData: AddressGroup;
}

export const AddressesCell: React.FC<AddressCellProps> = ({ addressGroupData }) => {
    const {fwVersionStore} = useStores();
    const [addresses, setAddresses] = useState<Address[]>([]);

    useEffect(() => {
        setAddresses(fwVersionStore.selectedVersionAddressesByGroup(addressGroupData));
    }, [addressGroupData]);

    return useMemo(() => listCells(addresses, 'address'),
        [addresses]);
};